import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function PredictorWeightsHeader({ sortConfig, requestSort, minWidth = 0 }) {
    return (
        <Container fluid style={{ minWidth }}>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none">
                <Col xs="auto" className="p-0" style={{ width: 10 }}></Col>
                <Col xs={3} onClick={() => requestSort("target_type")}>
                    <Stack direction="horizontal">
                        <span>Target Type</span>
                        <span className="col-1">{renderSortIcon("target_type", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col onClick={() => requestSort("target_id")}>
                    <Stack direction="horizontal">
                        <span>Target</span>
                        <span className="col-1">{renderSortIcon("target_id", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} onClick={() => requestSort("weight")}>
                    <Stack direction="horizontal">
                        <span className="offset-1">Weight</span>
                        <span className="col-1">{renderSortIcon("weight", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs="auto" style={{ width: 108 }}></Col>
            </Row>
        </Container>
    );
}
